import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=575a790c&scoped=true"
import script from "./mainInfo.vue?vue&type=script&lang=js"
export * from "./mainInfo.vue?vue&type=script&lang=js"
import style0 from "./mainInfo.vue?vue&type=style&index=0&id=575a790c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a790c",
  null
  
)

export default component.exports